Vue.component('product-section', () => import(/* webpackChunkName: "product-section" */ '@modulesPages/Site/Resources/assets/js/Sections/ProductSection'))
Vue.component('contact-section', () => import(/* webpackChunkName: "contact-section" */ '@modulesPages/Site/Resources/assets/js/Sections/ContactSection'))
Vue.component('contact-section2', () => import(/* webpackChunkName: "contact-section2" */ '@modulesPages/Site/Resources/assets/js/Sections/ContactSection2'))
Vue.component('contact-section3', () => import(/* webpackChunkName: "contact-section3" */ '@modulesPages/Site/Resources/assets/js/Sections/ContactSection3'))
Vue.component('ways-to-prepare-section', () => import(/* webpackChunkName: "ways-to-prepare-section" */ '@modulesPages/Site/Resources/assets/js/Sections/WaysToPrepareSection'))
Vue.component('we-recommend-you-section', () => import(/* webpackChunkName: "we-recommend-you-section" */ '@modulesPages/Site/Resources/assets/js/Sections/WeRecommendYouSection'))
Vue.component('map-section', () => import(/* webpackChunkName: "map-section" */ '@modulesPages/Site/Resources/assets/js/Sections/MapSection'))
Vue.component('distributor-contact-section', () => import(/* webpackChunkName: "distributor-contact-section" */ '@modulesPages/Site/Resources/assets/js/Sections/DistributorContactSection'))
Vue.component('cart-section', () => import(/* webpackChunkName: "cart-section" */ '@modulesPages/Site/Resources/assets/js/Sections/CartSection'))
Vue.component('welcome-section', () => import(/* webpackChunkName: "welcome-section" */ '@modulesPages/Site/Resources/assets/js/Sections/WelcomeSection'))
Vue.component('distinctives-section', () => import(/* webpackChunkName: "distinctives-section" */ '@modulesPages/Site/Resources/assets/js/Sections/DistinctivesSection'))
Vue.component('create-reservation-section', () => import(/* webpackChunkName: "create-reservation-section" */ '@modulesPages/Site/Resources/assets/js/Sections/CreateReservationSection'))
Vue.component('about-us-section', () => import(/* webpackChunkName: "about-us-section" */ '@modulesPages/Site/Resources/assets/js/Sections/AboutUsSection'))
Vue.component('vizion-about-us-section', () => import(/* webpackChunkName: "vizion-about-us-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionAboutUsSection'))
Vue.component('resta-values-section', () => import(/* webpackChunkName: "resta-values-section" */ '@modulesPages/Site/Resources/assets/js/Sections/RestaValuesSection'))
Vue.component('vizion-values-section', () => import(/* webpackChunkName: "vizion-values-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionValuesSection'))
Vue.component('vizion-brands-section', () => import(/* webpackChunkName: "vizion-brands-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionBrandsSection'))
Vue.component('vizion-we-are-different-section', () => import(/* webpackChunkName: "vizion-we-are-different-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionWeAreDifferentSection'))
Vue.component('vizion-we-are-we-located-section', () => import(/* webpackChunkName: "vizion-we-are-we-located-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionWeAreWeLocatedSection'))
Vue.component('vizion-about-tepatitlan-section', () => import(/* webpackChunkName: "vizion-about-tepatitlan-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionAboutTepatitlanSection'))
Vue.component('vizion-socioeconomic-section', () => import(/* webpackChunkName: "vizion-socioeconomic-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionSocioeconomicSection'))
Vue.component('vizion-gallery-section', () => import(/* webpackChunkName: "vizion-gallery-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionGallerySection'))
Vue.component('vizion-displays-section', () => import(/* webpackChunkName: "vizion-displays-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionDisplaysSection'))
Vue.component('vizion-display-info-section', () => import(/* webpackChunkName: "vizion-display-info-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VizionDisplayInfoSection'))
Vue.component('resta-what-do-we-do-section', () => import(/* webpackChunkName: "resta-what-do-we-do-section" */ '@modulesPages/Site/Resources/assets/js/Sections/RestaWhatDoWeDoSection'))
Vue.component('video-section', () => import(/* webpackChunkName: "video-section" */ '@modulesPages/Site/Resources/assets/js/Sections/VideoSection'))
Vue.component('grupodonk-we-are-section', () => import(/* webpackChunkName: "grupodonk-we-are-section" */ '@modulesPages/Site/Resources/assets/js/Sections/GrupoDonKWeAreSection'))
Vue.component('grupodonk-brands-section', () => import(/* webpackChunkName: "grupodonk-brands-section" */ '@modulesPages/Site/Resources/assets/js/Sections/GrupoDonKBrandsSection'))
Vue.component('grupodonk-brands-section2', () => import(/* webpackChunkName: "grupodonk-brands-section2" */ '@modulesPages/Site/Resources/assets/js/Sections/GrupoDonKBrandsSection2'))
Vue.component('grupodonk-philosophy-section', () => import(/* webpackChunkName: "grupodonk-philosophy-section" */ '@modulesPages/Site/Resources/assets/js/Sections/GrupodonkPhilosophySection'))
Vue.component('grupodonk-our-history-section', () => import(/* webpackChunkName: "grupodonk-our-history-section" */ '@modulesPages/Site/Resources/assets/js/Sections/GrupoDonKOurHistorySection'))

Vue.component('prepare-card', () => import(/* webpackChunkName: "prepare-card" */ '@modulesPages/Site/Resources/assets/js/Cards/PrepareCard'))
Vue.component('prepare-card2', () => import(/* webpackChunkName: "prepare-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/PrepareCard2'))
Vue.component('locations-card', () => import(/* webpackChunkName: "locations-card" */ '@modulesPages/Site/Resources/assets/js/Cards/LocationsCard'))
Vue.component('locations-card2', () => import(/* webpackChunkName: "locations-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/LocationsCard2'))
Vue.component('contact-phone-card', () => import(/* webpackChunkName: "contact-phone-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ContactPhoneCard'))
Vue.component('contact-email-card', () => import(/* webpackChunkName: "contact-email-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ContactEmailCard'))
Vue.component('contact-address-card', () => import(/* webpackChunkName: "contact-address-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ContactAddressCard'))
Vue.component('contact-service-card', () => import(/* webpackChunkName: "contact-service-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ContactServiceCard'))
Vue.component('carts-card', () => import(/* webpackChunkName: "carts-card" */ '@modulesPages/Site/Resources/assets/js/Cards/CartsCard'))
Vue.component('items-card', () => import(/* webpackChunkName: "items-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ItemsCard'))
Vue.component('items-card2', () => import(/* webpackChunkName: "items-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/ItemsCard2'))
Vue.component('orders-card', () => import(/* webpackChunkName: "orders-card" */ '@modulesPages/Site/Resources/assets/js/Cards/OrdersCard'))
Vue.component('distinctives-card', () => import(/* webpackChunkName: "distinctives-card" */ '@modulesPages/Site/Resources/assets/js/Cards/DistinctivesCard'))
Vue.component('gallery-card', () => import(/* webpackChunkName: "gallery-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GalleryCard'))
Vue.component('gallery-card2', () => import(/* webpackChunkName: "gallery-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/GalleryCard2'))
Vue.component('menus-card', () => import(/* webpackChunkName: "menus-card" */ '@modulesPages/Site/Resources/assets/js/Cards/MenusCard'))
Vue.component('experiences-card', () => import(/* webpackChunkName: "experiences-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ExperiencesCard'))
Vue.component('values-card', () => import(/* webpackChunkName: "values-card" */ '@modulesPages/Site/Resources/assets/js/Cards/ValuesCard'))
Vue.component('we-are-we-located-card', () => import(/* webpackChunkName: "we-are-we-located-card" */ '@modulesPages/Site/Resources/assets/js/Cards/WeAreWeLocatedCard'))
Vue.component('about-tepatitlan-card', () => import(/* webpackChunkName: "about-tepatitlan-card" */ '@modulesPages/Site/Resources/assets/js/Cards/AboutTepatitlanCard'))
Vue.component('grupodonk-brands-card', () => import(/* webpackChunkName: "grupodonk-brands-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GrupoDonKBrandsCard'))
Vue.component('grupodonk-brands-card2', () => import(/* webpackChunkName: "grupodonk-brands-card2" */ '@modulesPages/Site/Resources/assets/js/Cards/GrupoDonKBrandsCard2'))
Vue.component('grupodonk-philosophy-card', () => import(/* webpackChunkName: "grupodonk-philosophy-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GrupoDonKPhilosophyCard'))
Vue.component('grupodonk-our-history-card', () => import(/* webpackChunkName: "grupodonk-our-history-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GrupoDonKOurHistoryCard'))
Vue.component('grupodonk-we-are-card', () => import(/* webpackChunkName: "grupodonk-we-are-card" */ '@modulesPages/Site/Resources/assets/js/Cards/GrupoDonKWeAreCard'))
Vue.component('vizion-displays-card', () => import(/* webpackChunkName: "vizion-displays-card" */ '@modulesPages/Site/Resources/assets/js/Cards/VizionDisplaysCard'))
Vue.component('brand-pastor-card', () => import(/* webpackChunkName: "brand-pastor-card" */ '@modulesPages/Site/Resources/assets/js/Cards/Brands/BrandPastorCard'))
Vue.component('brand-resta-card', () => import(/* webpackChunkName: "brand-resta-card" */ '@modulesPages/Site/Resources/assets/js/Cards/Brands/BrandRestaCard'))
Vue.component('brand-vizion-card', () => import(/* webpackChunkName: "brand-vizion-card" */ '@modulesPages/Site/Resources/assets/js/Cards/Brands/BrandVizionCard'))
Vue.component('brand-tiendita-card', () => import(/* webpackChunkName: "brand-tiendita-card" */ '@modulesPages/Site/Resources/assets/js/Cards/Brands/BrandTienditaCard'))
Vue.component('brand-almacen-card', () => import(/* webpackChunkName: "brand-almacen-card" */ '@modulesPages/Site/Resources/assets/js/Cards/Brands/BrandAlmacenCard'))
Vue.component('alliances-card', () => import(/* webpackChunkName: "alliances-card" */ '@modulesPages/Site/Resources/assets/js/Cards/AlliancesCard'))

Vue.component('reservations-table', () => import(/* webpackChunkName: "reservations-table" */ '@modulesPages/Site/Resources/assets/js/Tables/ReservationsTable'))
Vue.component('galleries-table', () => import(/* webpackChunkName: "galleries-table" */ '@modulesPages/Site/Resources/assets/js/Tables/GalleriesTable'))
Vue.component('menus-table', () => import(/* webpackChunkName: "menus-table" */ '@modulesPages/Site/Resources/assets/js/Tables/MenusTable'))
Vue.component('displays-table', () => import(/* webpackChunkName: "displays-table" */ '@modulesPages/Site/Resources/assets/js/Tables/DisplaysTable'))
Vue.component('alliances-table', () => import(/* webpackChunkName: "alliances-table" */ '@modulesPages/Site/Resources/assets/js/Tables/AlliancesTable'))

Vue.component('mix-cart-form', () => import(/* webpackChunkName: "mix-cart-form" */ '@modulesPages/Site/Resources/assets/js/Forms/MixCartForm'))
Vue.component('reservations-form', () => import(/* webpackChunkName: "reservations-form" */ '@modulesPages/Site/Resources/assets/js/Forms/ReservationsForm'))
Vue.component('reservations-form2', () => import(/* webpackChunkName: "reservations-form2" */ '@modulesPages/Site/Resources/assets/js/Forms/ReservationsForm2'))
Vue.component('galleries-form', () => import(/* webpackChunkName: "galleries-form" */ '@modulesPages/Site/Resources/assets/js/Forms/GalleriesForm'))
Vue.component('menus-form', () => import(/* webpackChunkName: "menus-form" */ '@modulesPages/Site/Resources/assets/js/Forms/MenusForm'))
Vue.component('displays-form', () => import(/* webpackChunkName: "displays-form" */ '@modulesPages/Site/Resources/assets/js/Forms/DisplaysForm'))
Vue.component('alliances-form', () => import(/* webpackChunkName: "alliances-form" */ '@modulesPages/Site/Resources/assets/js/Forms/AlliancesForm'))

Vue.component('simple-banner', () => import(/* webpackChunkName: "simple-banner" */ '@modulesPages/Site/Resources/assets/js/Components/SimpleBanner'))
Vue.component('floating-whatsapp', () => import(/* webpackChunkName: "floating-whatsapp" */ '@modulesPages/Site/Resources/assets/js/Components/FloatingWhatsapp'))
Vue.component('distributor-search-form', () => import(/* webpackChunkName: "distributor-search-form" */ '@modulesPages/Site/Resources/assets/js/Components/DistributorSearchForm'))

Vue.component('google-map', () => import(/* webpackChunkName: "google-map" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMap'))
Vue.component('google-map-loader', () => import(/* webpackChunkName: "google-map-loader" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMapLoader'))
Vue.component('google-map-marker', () => import(/* webpackChunkName: "google-map-marker" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMapMarker'))
Vue.component('google-map-cluster', () => import(/* webpackChunkName: "google-map-cluster" */ '@modulesPages/Site/Resources/assets/js/Map/GoogleMapCluster'))


app.$Util.formattedClassName = {
	...app.$Util.formattedClassName,
	...{
		'Modules\\Site\\Entities\\Site': 'Página',
		'Modules\\Site\\Entities\\Reservation': 'Reservación',
		'Modules\\Site\\Entities\\Gallery': 'Galería',
		'Modules\\Site\\Entities\\Menu': 'Menú',
		'Modules\\Site\\Entities\\Display': 'Paquete',
	}	
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Site\\Entities\\Site': 'sites',
		'Modules\\Site\\Entities\\Reservation': 'reservations',
		'Modules\\Site\\Entities\\Gallery': 'galleries',
		'Modules\\Site\\Entities\\Menu': 'menus',
		'Modules\\Site\\Entities\\Display': 'displays',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'sites': 'Modules\\Site\\Entities\\Site',
		'reservations': 'Modules\\Site\\Entities\\Reservation',
		'galleries': 'Modules\\Site\\Entities\\Gallery',
		'menus': 'Modules\\Site\\Entities\\Menu',
		'displays': 'Modules\\Site\\Entities\\Display',
	}	
}

app.$Util.formattedStatus = {
	...app.$Util.formattedStatus,
	...{
		confirmed: 'Confirmado',
		rejected: 'Rechazado'
	}
}

app.$Util.variantStatus = {
	...app.$Util.variantStatus,
	...{
		confirmed: 'success',
		rejected: 'danger'
	}
}

app.$state.$banner.addForm(
	'home.eventos',
	'default-banners-form',
	'Home - Eventos'
)

app.$Util.getFormattedSiteName = function(siteName) {
	switch(siteName) {
		case 'grupodonk':
			siteName = 'Grupo Don K®'
        break

        case 'pastordonk':
			siteName = 'Pastor Don K®'
        break

        case 'vizion':
			siteName = 'Vizion'
        break

        case 'resta':
			siteName = 'Resta'
        break
	}

	return siteName
}

app.$state.getSitesIds = function() {
	return this.user
		? this.user.sites.map(s => s.id)
		: []
}

app.$state.configs = {
	grupodonk: {
		navbarLogo: '/images/grupodonk/logo.svg',
		footerLogo: '/images/grupodonk/logo2.svg',
		email: {
			text: 'administracion@grupodonk.com',
			url: 'mailto:administracion@grupodonk.com',
		},
		//whatsapp: {
		//	text: '378 124 2787',
		//	url: 'https://wa.me/5213781242787',
		//},
		phone: {
			text: '378 715 5140',
			url: 'tel:3787155140',
		},
		attentionSchedule: {
			es: [
				'Lunes a viernes - 9:00am a 5:00pm',
				'Sábado - 9:00am a 2:00pm'
			],
			en: [
				'Monday to Friday - 9:00am to 5:00pm',
				'Saturday - 9:00am to 2:00pm'
			]	
		},
		location: {
			text: {
				es: 'Calle Niños Héroes 453, Col. Centro, Tepatitlán de Morelos, Jalisco, México.',
				en: '453, Niños Héroes Street, Tepatitlán de Morelos Jal, 47650 México.'
			},
			url: 'https://goo.gl/maps/wJtAbapV4oo2GW1L7',
			iframe: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3729.5804289552443!2d-102.76692428461263!3d20.80825550064422!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842927d41f4cd43f%3A0xa2b7ae884a420068!2sC.%20Ni%C3%B1os%20Heroes%20453%2C%20Centro%2C%2047650%20Tepatitl%C3%A1n%20de%20Morelos%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1645782533359!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>'
		},
		contact: {
			banner: '/images/banners/19.png',
			primaryText: 'text-white',
			secondaryText: 'text-white',
			showAttentionSchedule: false,
			icons: {
				whatsapp: '/images/icons/whatsapp.svg',
				phone: '/images/icons/phone.svg',
				mail: '/images/icons/mail.svg',
				pin: '/images/icons/pin.svg',
				clock: '/images/icons/clock.svg'
			},
			emails: [
				{
					text: 'administracion@grupodonk.com',
					url: 'mailto:administracion@grupodonk.com'
				}
			]
		},
		footer: {
			showLogo: false,
			terms: false,
			privacy: true
		},
		hasSocials: false,
		emails: [
			{
				text: 'recursoshumanos@grupodonk.com',
				url: 'mailto:recursoshumanos@grupodonk.com',
			},
			{
				text: 'contabilidad@grupodonk.com',
				url: 'mailto:contabilidad@grupodonk.com',
			},
			{
				text: 'administracion@grupodonk.com',
				url: 'mailto:administracion@grupodonk.com',
			},
			{
				text: 'marketing@grupodonk.com',
				url: 'mailto:marketing@grupodonk.com',
			}
		]
	},

	pastordonk: {
		navbarLogo: '/images/pastordonk/logo.png',
		footerLogo: '/images/pastordonk/logo2.svg',
		facebook: {
			text: '@pastordonkmx',
			url: 'https://www.facebook.com/pastordonkmx'
		},
		instagram: {
			text: '@pastordonkmx',
			url: 'https://www.instagram.com/pastordonkmx'
		},
		email: {
			text: 'ventaspastor@grupodonk.com',
			url: 'mailto:ventaspastor@grupodonk.com',
		},
		whatsapp: {
			text: '378 124 2787',
			url: 'https://wa.me/5213781242787',
		},
		phone: {
			text: '378 715 5140',
			url: 'tel:3787155140',
		},
		attentionSchedule: {
			es: [
				'Lunes a viernes - 9:00am a 5:00pm',
				'Sábado - 9:00am a 2:00pm'
			],
			en: [
				'Monday to Friday - 9:00am to 5:00pm',
				'Saturday - 9:00am to 2:00pm'
			]
		},
		location: {
			text: {
				es: 'Calle Artículo 123 #309, Col. El pipón, 47650, Tepatitlán de Morelos, Jalisco, México.',
				en: '309, Artículo 123 Street, Tepatitlán de Morelos, Jal, 47650 México.'
			},
			url: 'https://goo.gl/maps/8KWiqPLK9UydCWKk7',
			iframe: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3729.603397517616!2d-102.7678429845377!3d20.807326986118728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842927d682132e13%3A0xd65bb84a4995edb5!2sC.%20Art%C3%ADculo%20123%20309%2C%20Alameda%2C%2047650%20Tepatitl%C3%A1n%20de%20Morelos%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1634784647343!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>'
		},
		contact: {
			banner: '/images/banners/6.jpg',
			primaryText: 'text-white',
			secondaryText: 'text-white',
			showAttentionSchedule: true,
			icons: {
				whatsapp: '/images/icons/whatsapp.svg',
				phone: '/images/icons/phone.svg',
				mail: '/images/icons/mail.svg',
				pin: '/images/icons/pin.svg',
				clock: '/images/icons/clock.svg'
			},
			emails: [
				{
					text: 'ventaspastor@grupodonk.com',
					url: 'mailto:ventaspastor@grupodonk.com'
				}
			]
		},
		footer: {
			showLogo: true,
			terms: true,
			privacy: true
		},
		hasSocials: true
	},

	resta: {
		navbarLogo: '/images/resta/logo.png',
		footerLogo: '/images/resta/logo2.svg',
		facebook: {
			text: '@DonKRestaurantBar',
			url: 'https://www.facebook.com/DonKRestaurantBar'
		},
		instagram: {
			text: '@donkrestaurant',
			url: 'https://www.instagram.com/donkrestaurant/?hl=es'
		},
		email: {
			text: 'donkrestaurant@grupodonk.com',
			url: 'mailto:donkrestaurant@grupodonk.com',
		},
		whatsapp: {
			text: '378 122 1439',
			url: 'https://wa.me/523781221439',
		},
		phone: {
			text: '378 715 5140',
			url: 'tel:3787155140',
		},
		attentionSchedule: {
			es: [
				'Lunes a jueves de 1:00pm a 12:00am',
				'Viernes y sábados de 1:00pm a 1:00am',
				'Domingo de 1:00pm a 8:00pm'
			],
			en: [
				'Monday to Thursday - 1:00pm to 12:00am',
				'Fridays and Saturdays - 1:00pm to 1:00am',
				'Sunday - 1:00pm to 8:00pm'
			]
		},
		location: {
			text: {
				es: 'Av. Dr. J. Ricardo Alcalá Íñiguez 284, El Pipón, 47650, Tepatitlán de Morelos, Jalisco, Mexico',
				en: '284, Dr. Ricardo Alcalá Street, Tepatitlán de Morelos, Jal, 47650 Mexico'
			},
			url: 'https://goo.gl/maps/31tGHMLAr3xFwDfD7',
			iframe: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3729.6214543994315!2d-102.76757328461265!3d20.80659700070016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842927d67f220ced%3A0x5f7c6397374d8309!2sAv.%20Dr.%20Jos%C3%A9%20Ricardo%20Alcal%C3%A1%20%C3%8D%C3%B1iguez%20284%2C%20Alameda%2C%2047650%20Tepatitl%C3%A1n%20de%20Morelos%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1645667727591!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>'
		},
		contact: {
			banner: '/images/banners/14.png',
			primaryText: 'text-green-site1',
			secondaryText: 'text-black',
			showAttentionSchedule: true,
			icons: {
				whatsapp: '/images/icons/whatsapp-green.svg',
				phone: '/images/icons/phone-green.svg',
				mail: '/images/icons/mail-green.svg',
				pin: '/images/icons/pin-green.svg',
				clock: '/images/icons/clock-green.svg'
			},
			emails: [
				{
					text: 'rp@grupodonk.com',
					url: 'mailto:rp@grupodonk.com'
				},
				{
					text: 'donkrestaurant@grupodonk.com',
					url: 'mailto:donkrestaurant@grupodonk.com'
				}
			]
		},
		footer: {
			showLogo: true,
			terms: false,
			privacy: true
		},
		hasSocials: true
	},

	vizion: {
		navbarLogo: '/images/vizion/logo.svg',
		footerLogo: '/images/vizion/logo2.png',
		facebook: {
			text: '@vizionpublicidadled',
			url: 'https://www.facebook.com/vizionpublicidadled/'
		},
		instagram: {
			text: '@vizionpublicidadled',
			url: 'https://www.instagram.com/vizionpublicidadled/'
		},
		email: {
			text: 'vizion@grupodonk.com',
			url: 'mailto:vizion@grupodonk.com',
		},
		whatsapp: {
			text: '378 186 9685',
			url: 'https://wa.me/5213781869685',
		},
		//phone: {
		//	text: '378 715 5140',
		//	url: 'tel:3787155140',
		//},
		attentionSchedule: {
			es: [
				'Lunes a viernes - 8:00am a 5:00pm',
				'Sábado - 8:00am a 2:00pm'
			],
			en: [
				'Monday to Friday - 8:00am to 5:00pm',
				'Saturday - 8:00am to 2:00pm'
			]	
		},
		location: {
			text: {
				es: 'Niños Heroes #453, Colonia Centro, C.P. 47650, Tepatitlán de Morelos, Jal.',
				en: '453, Niños Heroes Street, Tepatitlán de Morelos, Jal, 47650 México.'
			},
			url: 'https://goo.gl/maps/c2Wd3FZ6rfUh7cZcA',
			iframe: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3729.5804289552443!2d-102.7669242846126!3d20.80825550064423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842927d41f4cd43f%3A0xa2b7ae884a420068!2sC.%20Ni%C3%B1os%20Heroes%20453%2C%20Centro%2C%2047650%20Tepatitl%C3%A1n%20de%20Morelos%2C%20Jal.!5e0!3m2!1ses-419!2smx!4v1645749053601!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>'
		},
		contact: {
			banner: '/images/banners/16.png',
			primaryText: 'text-white',
			secondaryText: 'text-white',
			showAttentionSchedule: true,
			icons: {
				whatsapp: '/images/icons/whatsapp.svg',
				phone: '/images/icons/phone.svg',
				mail: '/images/icons/mail.svg',
				pin: '/images/icons/pin.svg',
				clock: '/images/icons/clock.svg'
			},
			emails: [
				{
					text: 'vizion@grupodonk.com',
					url: 'mailto:vizion@grupodonk.com'
				}
			]
		},
		footer: {
			showLogo: true,
			terms: false,
			privacy: true
		},
		hasSocials: true
	}
}

app.$state.config = app.$state.configs[app.$state.site_name]